<template>
  <div id="page" class="back-layout bg-light">
    <header><navbar id="nav"/></header>
    <router-view id="page-content" class="container-fluid back-page-content" role="main" />
    <footer class="footer">Copyright @2019 <a href="https://www.teicee.com" target="_blank">téïcée</a> - v 0.x</footer>
    <b-modal :title="errorTitle" ref="errorModal" ok-only centered
             @ok="$router.go(-1)"
    >
      {{ errorMsg }}
    </b-modal>
  </div>
</template>

<script>
import navbar from '@/components/backoffice/navbar'
import axios from "axios";

export default {
  components: {
    navbar
  },

  data () {
    return {
      errorTitle: "",
      errorMsg: ""
    }
  },

  created () {
    this.errorTitle = this.$t('error.error')
    this.errorMsg = this.$t('error.error')

    axios.interceptors.response.use(undefined, (err) => {
      return new Promise(() => {
        if (err.response !== undefined) {
          switch (err.response.status) {
            case 403:
              this.errorMsg = this.$t('error.403')
              this.$refs.errorModal.show()
              break
            case 500:
            case 503:
            default:
              this.errorMsg = this.$t('error.500back')
              this.$refs.errorModal.show()
              break
          }
          throw err
        }
      })
    })
  }
}
</script>

<style lang="scss">
html {
    position: relative;
    min-height: 100%;
}
  .back-layout {
    padding-bottom: 80px;
    @import '../../assets/sass/backoffice/main.scss';
  }
</style>
